<h3 class="title configurator-title">{{ 'closet-doors.summary.title' | translate }}</h3>

<div class="summary-container shadow">
  <h4 class="title summary-title">{{ 'closet-doors.summary.doors' | translate }}</h4>
  <div class="summary-infos">
    <p class="info">
      {{ 'closet-doors.summary.dimensions' | translate }} : {{ resume.clientHeight }} x {{ resume.clientWidth }} mm
    </p>
    <p class="info">{{ 'closet-doors.summary.final-dimensions' | translate }} : {{ resume.doorRealWidth }} mm</p>
    <p class="info">
      {{ 'closet-doors.summary.opening-percentage' | translate }} : {{ resume.panel.openingPercentage }} %
    </p>
    <p class="info">{{ resume.panel.doors.length }} vantaux - {{ resume.panel.doorDescription }}</p>
    <!--<p class="info">{{ resume.railNameFr }}</p>-->
  </div>
</div>

<div class="summary-container shadow mt-4">
  <h4 class="title summary-title">{{ 'closet-doors.summary.structure' | translate }}</h4>
  <div class="summary-infos">
    <p class="info" *ngFor="let structure of getStructures()">{{ structure.description }} : {{ structure.count }}</p>
    <p class="info">{{ 'closet-doors.summary.frame-type' | translate }} : {{ resume.panel.frameTypeName }}</p>
    <p class="info">{{ 'closet-doors.summary.frame' | translate }} : {{ resume.panel.frameFr }}</p>
    <p class="info">{{ 'closet-doors.summary.finition' | translate }} : {{ resume.panel.profileFr }}</p>
  </div>
</div>

<div class="summary-container shadow mt-4" *ngFor="let door of sortedDoors()">
  <h4 class="title summary-title">{{ 'closet-doors.summary.door-decoration' | translate }} {{ door.index }}</h4>
  <div class="summary-infos">
    <p class="info">{{ door.doorTypeFr }}</p>
    <p class="info" *ngFor="let color of door.colorsFr">{{ color }}</p>
    <p class="info">{{ resume.panel.prestationFr }}</p>
  </div>
</div>

<div class="summary-container shadow mt-4" *ngIf="resume.baseboardCompensator">
  <h4 class="title summary-title">{{ 'closet-doors.summary.accessories' | translate }}</h4>
  <div class="summary-infos">
    <p class="info">{{ resume.baseboardCompensator }} : {{ resume.baseboardCompensatorQty }}</p>
  </div>
</div>

<div class="summary-container prices-container shadow mt-4">
  <div class="price-row">
    <h4 class="title summary-title">{{ 'closet-doors.summary.total-without-vat' | translate }} :</h4>
    <p class="info">{{ resume.totalHT | number: '1.2-2' : 'fr' }} €</p>
  </div>
  <div class="price-row">
    <h4 class="title summary-title">{{ 'closet-doors.summary.vat-total' | translate }} :</h4>
    <p class="info">{{ resume.totalPV - resume.totalHT | number: '1.2-2' : 'fr' }} €</p>
  </div>
  <div class="price-row principale">
    <h4 class="title summary-title">{{ 'closet-doors.summary.total-with-vat' | translate }} :</h4>
    <p class="info">{{ resume.totalPV | number: '1.2-2' : 'fr' }} €</p>
  </div>
  <div class="price-row">
    <h1 class="title summary-title">{{ 'closet-doors.summary.ecotaxe-with-vat' | translate }}</h1>
    <p class="info">{{ resume.ecoTax | number: '1.2-2' : 'fr' }} €</p>
  </div>
</div>
